import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { RestClientPaged } from '@elderbyte/ngx-starter'
import { environment } from '../../../../../environments/environment'
import { WorkCenterType } from './work-center-type'

@Injectable({
  providedIn: 'root',
})
export class WorkCenterTypeService extends RestClientPaged<WorkCenterType, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/work-centers/types', http, {
      idField: 'id',
    })
  }
}
